import React from "react";
import { cn } from "@/lib/utils";
import { statusColor, priorityColor } from "@/lib/helpers";

export function StatusBadge({ status, className }) {
  const label = (status || "").replace(/_/g, " ");
  return (
    <span
      data-testid={`status-${status}`}
      className={cn("inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-medium capitalize", statusColor(status), className)}
    >
      {label || "—"}
    </span>
  );
}

export function PriorityBadge({ priority }) {
  return (
    <span className={cn("inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-medium capitalize", priorityColor(priority))}>
      {priority}
    </span>
  );
}
